/* ============================================================
   VELTRIX — Theme JS
   ============================================================ */
(function () {
  'use strict';

  /* Loader runs as an inline script in theme.liquid (self-contained,
     independent of this file loading) — see layout/theme.liquid. */

  /* ── Header scroll state ─────────────────────────────────── */
  const Header = {
    init() {
      const header = document.querySelector('.site-header');
      if (!header) return;
      const transparent = header.classList.contains('site-header--transparent');
      if (!transparent) return;

      let ticking = false;
      const update = () => {
        header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.6);
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      update();
    }
  };

  /* ── Mobile nav ──────────────────────────────────────────── */
  const MobileNav = {
    init() {
      const burger = document.querySelector('.header__burger');
      const nav = document.querySelector('.mobile-nav');
      const close = document.querySelector('.mobile-nav__close');
      if (!burger || !nav) return;
      const toggle = (open) => {
        nav.classList.toggle('open', open);
        document.body.style.overflow = open ? 'hidden' : '';
        burger.setAttribute('aria-expanded', open);
      };
            const overlay = nav.querySelector('.mobile-nav__overlay');
      burger.addEventListener('click', () => toggle(!nav.classList.contains('open')));
      close && close.addEventListener('click', () => toggle(false));
      overlay && overlay.addEventListener('click', () => toggle(false));
      nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => toggle(false)));
      burger.addEventListener('click', () => toggle(!nav.classList.contains('open')));
      close && close.addEventListener('click', () => toggle(false));
      nav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => toggle(false)));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') toggle(false); });
    }
  };

  /* ── Announcement close ──────────────────────────────────── */
  const Announcement = {
    init() {
      const bar = document.querySelector('.announcement-bar');
      const btn = document.querySelector('.announcement-bar__close');
      if (!bar || !btn) return;
      if (sessionStorage.getItem('veltrix-ann-closed')) {
        bar.style.display = 'none';
        document.documentElement.classList.add('no-announcement');
      }
      btn.addEventListener('click', () => {
        bar.style.display = 'none';
        document.documentElement.classList.add('no-announcement');
        sessionStorage.setItem('veltrix-ann-closed', '1');
      });
    }
  };

  /* ── Cart drawer ─────────────────────────────────────────── */
  const Cart = {
    init() {
      this.drawer = document.querySelector('.cart-drawer');
      this.overlay = document.querySelector('.cart-overlay');
      if (!this.drawer) return;

      document.querySelectorAll('[data-cart-open]').forEach(b =>
        b.addEventListener('click', e => { e.preventDefault(); this.open(); }));
      document.querySelectorAll('[data-cart-close]').forEach(b =>
        b.addEventListener('click', () => this.close()));
      this.overlay && this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });

      this.bindQty();
    },
    open() { this.drawer.classList.add('open'); this.overlay && this.overlay.classList.add('open'); document.body.style.overflow = 'hidden'; this.fetch(); },
    close() { this.drawer.classList.remove('open'); this.overlay && this.overlay.classList.remove('open'); document.body.style.overflow = ''; },

    async fetch() {
      try {
        const cart = await (await fetch('/cart.js')).json();
        this.count(cart.item_count);
        this.render(cart);
      } catch (e) { /* noop */ }
    },
    count(n) {
      document.querySelectorAll('.header__cart-count').forEach(el => {
        el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none';
      });
    },
    render(cart) {
      const wrap = this.drawer.querySelector('.cart-drawer__items');
      const sub = this.drawer.querySelector('.cart-drawer__subtotal-amount');
      const cnt = this.drawer.querySelector('.cart-drawer__count');
      if (cnt) cnt.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      if (sub) sub.textContent = money(cart.total_price);
      const foot = this.drawer.querySelector('.cart-drawer__foot');
      if (!wrap) return;

      if (!cart.items.length) {
        wrap.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--outline-ink" data-cart-close>Shop</a></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      wrap.innerHTML = cart.items.map(i => `
        <div class="cart-line" data-key="${i.key}">
          <img class="cart-line__img" src="${i.image}" alt="">
          <div>
            <div class="cart-line__name">${i.product_title}</div>
            ${i.variant_title && i.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${i.variant_title}</div>` : ''}
            <div class="cart-line__row">
              <div class="cart-qty">
                <button data-qty="-1" data-key="${i.key}" aria-label="Decrease">–</button>
                <span>${i.quantity}</span>
                <button data-qty="1" data-key="${i.key}" aria-label="Increase">+</button>
              </div>
              <div class="cart-line__price">${money(i.line_price)}</div>
            </div>
          </div>
        </div>`).join('');
      this.bindQty();
    },
    bindQty() {
      this.drawer.querySelectorAll('[data-qty]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const line = btn.closest('.cart-line');
          const cur = parseInt(line.querySelector('span').textContent, 10);
          const next = Math.max(0, cur + parseInt(btn.dataset.qty, 10));
          await fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: next })
          });
          this.fetch();
        });
      });
    },
    async add(id, qty = 1) {
      await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      });
      this.fetch(); this.open();
    }
  };

  /* ── Product form (PDP) ──────────────────────────────────── */
  const ProductForm = {
    init() {
      const form = document.querySelector('.js-product-form');
      if (!form) return;

      this.variants = window.VELTRIX_VARIANTS || [];
      this.selected = {};
      form.querySelectorAll('[data-option-index]').forEach(group => {
        const sel = group.querySelector('.swatch.selected');
        if (sel) this.selected[group.dataset.optionIndex] = sel.dataset.value;
      });

      form.querySelectorAll('.swatch').forEach(sw => {
        sw.addEventListener('click', () => {
          if (sw.classList.contains('unavailable')) return;
          const group = sw.closest('[data-option-index]');
          group.querySelectorAll('.swatch').forEach(s => s.classList.remove('selected'));
          sw.classList.add('selected');
          const lbl = group.querySelector('[data-selected-value]');
          if (lbl) lbl.textContent = sw.dataset.value;
          this.selected[group.dataset.optionIndex] = sw.dataset.value;
          this.update(form);
        });
      });

      form.addEventListener('submit', async e => {
        e.preventDefault();
        const id = form.querySelector('[name="id"]').value;
        const btn = form.querySelector('[type="submit"]');
        const orig = btn.textContent;
        btn.textContent = 'Adding…'; btn.disabled = true;
        await Cart.add(id);
        btn.textContent = 'Added';
        setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1600);
      });
    },
    update(form) {
      const match = this.variants.find(v =>
        v.options.every((opt, i) => this.selected[i] === undefined || this.selected[i] === opt));
      const idInput = form.querySelector('[name="id"]');
      const priceEl = document.querySelector('[data-pdp-price]');
      const btn = form.querySelector('[type="submit"]');
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.compare_at_price > match.price
        ? `${money(match.price)} <s>${money(match.compare_at_price)}</s>`
        : money(match.price);
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  };

  /* ── PDP accordion ───────────────────────────────────────── */
  const Accordion = {
    init() {
      document.querySelectorAll('.pdp__acc-head').forEach(h => {
        h.addEventListener('click', () => h.closest('.pdp__acc-item').classList.toggle('open'));
      });
    }
  };

  /* ── Quick add (cards) ───────────────────────────────────── */
  const QuickAdd = {
    init() {
      document.querySelectorAll('[data-quick-add]').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault(); e.stopPropagation();
          Cart.add(parseInt(btn.dataset.quickAdd, 10));
        });
      });
    }
  };

  /* ── Reveal on scroll ────────────────────────────────────── */
  const Reveal = {
    init() {
      const els = document.querySelectorAll('.reveal');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); obs.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
      els.forEach(e => obs.observe(e));
    }
  };

  /* ── Utils ───────────────────────────────────────────────── */
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(cents / 100);
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  document.addEventListener('DOMContentLoaded', () => {
    Header.init();
    MobileNav.init();
    Announcement.init();
    Cart.init();
    ProductForm.init();
    Accordion.init();
    QuickAdd.init();
    Reveal.init();
  });

  window.VeltrixCart = Cart;
})();
